var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mosaic-grid",attrs:{"id":"mosaic-grid"}},[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.error)?_c('Error'):_vm._e(),_vm._l((_vm.children),function(child,i){return _c('GridItem',{key:i,attrs:{"child":child}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }